import { render, staticRenderFns } from "./FormUsuario.vue?vue&type=template&id=7a72897d&"
import script from "./FormUsuario.vue?vue&type=script&lang=js&"
export * from "./FormUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports